import React from "react";
import {Route,Redirect} from 'react-router-dom';
import Agent from "../../api/agent";


export default class OldArtworkPatterns extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            apiRes: false,
            fromURL: props.location.pathname,
            toURL: '',
        };
    }

    RedirectNewUrl = (artworkId) => {
        Agent.generalData.artworkSlug(artworkId).then((res) => {
            console.log('share_url', res.data[0].artwork.share_url);
            if (res.error == 'False') {
                this.setState({
                    toURL: '/product/details/' + res.data[0].artwork.url_slug,
                    apiRes: true,
                })
            }
        });

    };

    componentWillMount() {
        let ArtWorkId = this.props.location.pathname.split('-').pop();
        this.RedirectNewUrl(ArtWorkId);
    }

    render() {

        if (!this.state.apiRes) {
            return null;
        } else {
            return (
                <Route path={this.state.fromURL} render={() => (
                    <Redirect to={this.state.toURL} />
                )}/>
                
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/static/old-artwork-urls.js